/* JTC Wholesale conversion helpers: unit price, tier bar, quick order, min-order guard */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- 1. Per-unit price on product page ---------- */
  function initUnitPrice() {
    document.querySelectorAll('[data-jtc-price-wrap]').forEach(function (wrap) {
      var el = wrap.querySelector('[data-jtc-unit-price]');
      if (!el) return;
      function update() {
        var src = wrap.getAttribute('data-jtc-src') || '';
        var m = src.match(/(\d+)\s*(pr|prs|pairs?|pcs|pieces?)\b/i);
        if (!m) { el.hidden = true; return; }
        var qty = parseInt(m[1], 10);
        if (qty < 2 || qty > 2000) { el.hidden = true; return; }
        var unit = /^(pc|pcs|piece|pieces)$/i.test(m[2]) ? 'pc' : 'pair';
        var cents = parseInt(wrap.getAttribute('data-price-cents') || '0', 10);
        if (!(cents > 0)) { el.hidden = true; return; }
        var text = '(' + money(Math.round(cents / qty)) + ' / ' + unit + ')';
        if (el.textContent !== text) el.textContent = text;
        el.hidden = false;
      }
      update();
      new MutationObserver(update).observe(wrap, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-price-cents', 'data-jtc-src'] });
    });
  }

  /* ---------- 2. Discount tier progress bar (cart drawer + cart page) ---------- */
  var TIERS = [
    { min: 300, code: 'JTC3', pct: 3 },
    { min: 500, code: 'JTC5', pct: 5 },
    { min: 1000, code: 'JTC7', pct: 7 },
    { min: 3000, code: 'JTC10', pct: 10 }
  ];
  function tierHtml(dollars) {
    var cur = null, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (dollars >= TIERS[i].min) cur = TIERS[i];
      else { next = TIERS[i]; break; }
    }
    function bar(pct) {
      return '<div class="jtc-tier-track"><div class="jtc-tier-fill" style="width:' + Math.min(100, pct) + '%"></div></div>';
    }
    function shipMsg() {
      if (dollars >= 500) return '<div class="jtc-tier-msg">🚚 <strong>Free standard shipping</strong> unlocked</div>';
      if (dollars >= 100) return '<div class="jtc-tier-msg jtc-tier-hint">🚚 ' + money((500 - dollars) * 100) + ' away from <strong>free standard shipping</strong></div>';
      return '';
    }
    if (dollars < 100) {
      return '<div class="jtc-tier-msg">Minimum order is <strong>$100</strong> — add <strong>' + money((100 - dollars) * 100) + '</strong> more.</div>' + bar(dollars);
    }
    if (!cur && next) {
      var need = next.min - dollars;
      return '<div class="jtc-tier-msg">Add <strong>' + money(need * 100) + '</strong> more to unlock <strong>' + next.code + '</strong> · ' + next.pct + '% off <span class="jtc-tier-hint">(enter code at checkout)</span></div>' + bar(dollars / next.min * 100) + shipMsg();
    }
    if (cur && next) {
      var need2 = next.min - dollars;
      return '<div class="jtc-tier-msg"><strong>' + cur.code + ' unlocked</strong> — ' + cur.pct + '% off with code <strong>' + cur.code + '</strong> at checkout · ' + money(need2 * 100) + ' more for <strong>' + next.code + '</strong> ' + next.pct + '% off</div>' + bar(dollars / next.min * 100) + shipMsg();
    }
    return '<div class="jtc-tier-msg"><strong>' + cur.code + ' unlocked</strong> — top tier ' + cur.pct + '% off with code <strong>' + cur.code + '</strong> at checkout</div>' + bar(100) + shipMsg();
  }
  function initTierBar() {
    var bars = document.querySelectorAll('[data-jtc-tier-bar]');
    if (!bars.length) return;
    var timer = null;
    function refresh() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var html = tierHtml(cart.total_price / 100);
        bars.forEach(function (b) {
          if (b.innerHTML !== html) b.innerHTML = html;
          b.hidden = false;
        });
      }).catch(function () {});
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 400); }
    refresh();
    var target = document.getElementById('CartDrawer') || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 3. Quick order by SKU ---------- */
  function initQuickOrder() {
    var table = document.getElementById('jtc-qo-table');
    if (!table) return;
    var tbody = table.querySelector('tbody');
    function addRow() {
      var tr = document.createElement('tr');
      tr.innerHTML = '<td><input type="text" class="jtc-qo-sku" placeholder="e.g. G644" autocomplete="off"></td>' +
        '<td><input type="number" class="jtc-qo-qty" value="1" min="1"></td>' +
        '<td class="jtc-qo-status"></td>';
      tbody.appendChild(tr);
    }
    for (var i = 0; i < 5; i++) addRow();
    document.getElementById('jtc-qo-add-row').addEventListener('click', function () {
      for (var j = 0; j < 5; j++) addRow();
    });
    function findVariant(sku) {
      return fetch('/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=5')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var products = (d.resources && d.resources.results && d.resources.results.products) || [];
          var chain = Promise.resolve(null);
          products.forEach(function (p) {
            chain = chain.then(function (found) {
              if (found) return found;
              return fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); }).then(function (pj) {
                var v = (pj.variants || []).find(function (x) { return (x.sku || '').toLowerCase() === sku.toLowerCase(); });
                if (!v) v = (pj.variants || []).find(function (x) { return x.available; }) || pj.variants[0];
                return v ? { id: v.id, title: pj.title + ' / ' + v.title } : null;
              }).catch(function () { return null; });
            });
          });
          return chain;
        });
    }
    document.getElementById('jtc-qo-submit').addEventListener('click', function () {
      var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr'));
      var jobs = rows.map(function (tr) {
        return {
          tr: tr,
          sku: tr.querySelector('.jtc-qo-sku').value.trim(),
          qty: Math.max(1, parseInt(tr.querySelector('.jtc-qo-qty').value, 10) || 0),
          status: tr.querySelector('.jtc-qo-status')
        };
      }).filter(function (j) { return j.sku; });
      if (!jobs.length) return;
      var btn = document.getElementById('jtc-qo-submit');
      btn.disabled = true;
      btn.textContent = 'Adding...';
      var chain = Promise.resolve();
      jobs.forEach(function (job) {
        chain = chain.then(function () {
          job.status.textContent = 'Looking up...';
          return findVariant(job.sku).then(function (v) {
            if (!v) { job.status.textContent = 'SKU not found'; return null; }
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: job.qty })
            }).then(function (r) {
              if (!r.ok) throw new Error('add failed');
              job.status.textContent = 'Added: ' + v.title;
            }).catch(function () { job.status.textContent = 'Add failed'; });
          });
        });
      });
      chain.then(function () {
        btn.disabled = false;
        btn.textContent = 'Add all to cart';
        window.location.href = '/cart';
      });
    });
  }

  /* ---------- 1b. Per-unit price: classic product template fallback ---------- */
  function initUnitPriceClassic() {
    if (!document.querySelector('[data-product-price]')) return;
    if (document.querySelector('[data-jtc-price-wrap]')) return; /* flex already handled */
    var priceEl = document.querySelector('[data-product-price]');
    var titleEl = document.querySelector('meta[property="og:title"]');
    var descEl = document.querySelector('meta[name="description"]');
    var src = ((titleEl && titleEl.content) || '') + ' ' + ((descEl && descEl.content) || '');
    var m = src.match(/(\d+)\s*(pr|prs|pairs?|pcs|pieces?)\b/i);
    if (!m) return;
    var qty = parseInt(m[1], 10);
    if (qty < 2 || qty > 2000) return;
    var unit = /^(pc|pcs|piece|pieces)$/i.test(m[2]) ? 'pc' : 'pair';
    var div = document.createElement('div');
    div.className = 'jtc-unit-price';
    div.style.cssText = 'font-size:13px;color:#666;margin-top:4px;';
    priceEl.parentNode.insertBefore(div, priceEl.nextSibling);
    function update() {
      var t = (priceEl.textContent || '').replace(/,/g, '');
      var pm = t.match(/\$\s*(\d+(?:\.\d{1,2})?)/);
      if (!pm) return;
      var price = parseFloat(pm[1]);
      if (!(price > 0)) return;
      div.textContent = '(' + money(Math.round(price / qty * 100)) + ' / ' + unit + ')';
    }
    update();
    new MutationObserver(update).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- 4. Minimum order guard ($100): intercept checkout button ---------- */
  var MIN_ORDER_CENTS = 10000; // $100 minimum order

  function minOrderModal(totalCents) {
    var old = document.getElementById('jtc-minorder-modal');
    if (old) old.remove();
    var need = MIN_ORDER_CENTS - totalCents;
    var css = '<style>' +
      '#jtc-minorder-modal{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:20px;box-sizing:border-box}' +
      '#jtc-minorder-box{background:#fff;border-radius:10px;max-width:400px;width:100%;padding:30px 26px;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,.25)}' +
      '#jtc-minorder-box h3{margin:0 0 10px;font-size:19px}' +
      '#jtc-minorder-box p{margin:0 0 22px;font-size:14px;line-height:1.65;color:#555}' +
      '#jtc-minorder-continue{cursor:pointer}' +
      '#jtc-minorder-quick{display:inline-block;margin-top:14px;font-size:13px;text-decoration:underline}' +
      '</style>';
    var html = '<div id="jtc-minorder-modal" role="dialog" aria-modal="true">' +
      '<div id="jtc-minorder-box">' +
      '<h3>Minimum order $100</h3>' +
      '<p>Your current subtotal is <strong>' + money(totalCents) + '</strong>.<br>Add <strong>' + money(need) + '</strong> more to reach our $100 minimum order.</p>' +
      '<button type="button" class="btn" id="jtc-minorder-continue">Continue shopping</button><br>' +
      '<a id="jtc-minorder-quick" href="/pages/quick-order">Go to Quick Order</a>' +
      '</div></div>';
    document.body.insertAdjacentHTML('beforeend', css + html);
    function close() {
      var m = document.getElementById('jtc-minorder-modal');
      if (m) m.remove();
    }
    document.getElementById('jtc-minorder-continue').addEventListener('click', close);
    document.getElementById('jtc-minorder-modal').addEventListener('click', function (e) {
      if (e.target === this) close();
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

  function proceedToCheckout(form) {
    // 走原生表单提交（补上 checkout 参数，保证行为和原来完全一致，购物车备注等不受影响）
    if (form && form.tagName === 'FORM') {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = '';
      form.appendChild(hidden);
      form.submit();
    } else {
      window.location.href = '/checkout';
    }
  }

  function initMinOrderGuard() {
    document.addEventListener('click', function (e) {
      var btn = (e.target && e.target.closest) ? e.target.closest('[name="checkout"]') : null;
      if (!btn) return;
      var form = btn.closest('form');
      e.preventDefault();
      e.stopPropagation();
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var total = (cart && cart.total_price) || 0;
        if (total >= MIN_ORDER_CENTS) {
          proceedToCheckout(form);
        } else {
          minOrderModal(total);
        }
      }).catch(function () {
        // 拿不到购物车数据时放行，不卡住客人
        proceedToCheckout(form);
      });
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initUnitPrice();
    initUnitPriceClassic();
    initTierBar();
    initQuickOrder();
    initMinOrderGuard();
  });
})();
